import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-become-model-dialog',
  template: `
    <h2 mat-dialog-title>Become a Model</h2>
    <mat-dialog-content>
      <p>
        You're about to upgrade your account to a <strong>model profile</strong>.
        Your existing client data will be used to create your model profile.
      </p>
      <p class="warning-text">
        <mat-icon class="warning-icon">warning</mat-icon>
        <strong>This action cannot be undone.</strong>
      </p>
      <p>Once upgraded, you'll have access to model features like content management,
        profile views, and more.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" [disabled]="isProcessing">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="isProcessing"
              style="position:relative; min-width:120px;">
        <ng-container *ngIf="!isProcessing; else processingTpl">Confirm</ng-container>
        <ng-template #processingTpl>
          <span style="display:flex; justify-content:center; align-items:center; width:100%; height:100%;">
            <mat-spinner diameter="24"></mat-spinner>
          </span>
        </ng-template>
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .warning-text {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #f44336;
      margin: 12px 0;
    }
    .warning-icon {
      font-size: 20px;
      height: 20px;
      width: 20px;
      color: #f44336;
    }
  `]
})
export class BecomeModelDialogComponent {
  isProcessing = false;

  constructor(
    public dialogRef: MatDialogRef<BecomeModelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    this.isProcessing = true;
    // The calling component handles the actual upgrade logic;
    // close with `true` to signal confirmation.
    this.dialogRef.close(true);
  }

  onCancel(): void {
    if (!this.isProcessing) {
      this.dialogRef.close(false);
    }
  }
}
